import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { cloneElement, useCallback, useRef } from 'react';
import { Overlay } from '../Overlay';
import { useTriggerShowHandlers } from './useTriggerShowHandlers';
import { useTriggerProps } from './useTriggerProps';
import { getChildProps, normalizeTrigger, normalizeDelay } from './utils';
const OverlayTrigger = ({ trigger = [
    'hover',
    'focus'
], overlay, children, popperConfig = {}, show: propsShow, defaultShow = false, onToggle, delay: propsDelay, placement, flip = placement && placement.includes('auto'), ...props })=>{
    const triggerNodeRef = useRef(null);
    const getTarget = useCallback(()=>triggerNodeRef.current, []);
    const { onFocus, onBlur, onClick } = getChildProps(children);
    const triggers = normalizeTrigger(trigger);
    const delay = normalizeDelay(propsDelay);
    const { handleShow, handleHide, handleToggle, show } = useTriggerShowHandlers({
        propsShow,
        defaultShow,
        onToggle,
        delay
    });
    const triggerProps = useTriggerProps({
        handleHide,
        handleShow,
        handleToggle,
        triggers,
        onFocus,
        onBlur,
        onClick
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            typeof children === 'function' ? children({
                ...triggerProps,
                ref: triggerNodeRef
            }) : /*#__PURE__*/ cloneElement(children, {
                ...triggerProps,
                ref: triggerNodeRef
            }),
            /*#__PURE__*/ _jsx(Overlay, {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: getTarget,
                children: overlay
            })
        ]
    });
};
export { OverlayTrigger };
